export const preloadedValues = {
    ncmsRecStatus: false,
    ncmsNCM: "",
    ncmsCodigoEX: "",
    ncmsDescricao: "",
    ncmsIPIModalidadeBC: -1,
    ncmsIPIAliquota: null,
  };